import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import cl from 'classnames'

import { useClientOnly } from '@hooks/useClientOnly';
import css from './ImageSlider.module.scss';

export const PagesDotes = ({ count, current }: { count: number, current: number }) => (
    <div className={css.paggination}>
        {  Array.from({ length: count }).map((image, i) => {
            return (<div className={`${css.pagerDot} ${current === i ? css.active : ''}`} key={i}/>)
        }) }
    </div>
)

interface Props {
    // if controls hidden, they will appear on hover only and paggination dots will be hidden always
    isHiddenControls: boolean;
    handlePrevious: () => void;
    handleNext: () => void;
}

function Paggination({
    isHiddenControls,
    handlePrevious,
    handleNext,
}: Props) {
    const isClient = useClientOnly();

    if(!isClient) return null;

    return (<>
        <button className={cl(css.previous, {[css.hide]: isHiddenControls})} onClick={handlePrevious} tabIndex={0}>
            <span className={css.circle} aria-hidden><Icon icon={faChevronLeft} /></span>
            <span className={css.a11y}>Previous</span>
        </button>
        <button className={cl(css.next, {[css.hide]: isHiddenControls})} onClick={handleNext} tabIndex={0}>
            <span className={css.circle} aria-hidden><Icon icon={faChevronRight} /></span>
            <span className={css.a11y}>Next</span>
        </button>
    </>)
}

export default React.memo(Paggination);